import type { PopperProps } from '@mui/material/Popper';
import Popper from '@mui/material/Popper';
import { styled } from '@mui/material/styles';

export const AutocompletePopperComponent = styled(
  (props: PopperProps) => <Popper {...props} placement="bottom-start" />,
  {
    name: 'Filter',
    slot: 'PopperComponent',
  }
)(({ theme }) => ({
  '.MuiAutocomplete-paper': {
    boxShadow: theme.shadows[4],
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    minWidth: 250,
    maxWidth: 500,
  },
  '.MuiAutocomplete-option': {
    fontSize: theme.typography.body2.fontSize,
    whiteSpace: 'nowrap',
  },
}));
